import React from "react";
import styles from "./styles.css";
import CARICON from "./images/caricon.svg";
import { cmsURl } from "../../../constants/url-constants";

const CarNoImperfection = () => {
    return (
        <div styleName={"styles.noImperfectionsTab"}>
            <img src={CARICON} alt="No Imperfections" />
            <p styleName={"styles.noImperfectionsText"}>
                <strong>FAIR WEAR AND TEAR ONLY</strong>
                This car had no reportable imperfections but may have minor defects under Fair Wear & Tear
            </p>
            <a href={`${cmsURl()}/car-quality-standards-cars24/`} target="__blank">
                SEE OUR IMPERFECTIONS GUIDE
            </a>
        </div>
    );
};

export default CarNoImperfection;
